export const initialState = {
    passwordIsValid : false,
    textboxType: "password",
    currentPassword: "",

};

export const SettingsReducer = (state = initialState, action) => { 
    switch(action.type){
        case 'isPasswordValid': {
            return {
                ...state,
                passwordIsValid: action.payload,
            };
        }
        case 'setTextboxType': {
            return {
                ...state,
                textboxType: action.payload,
            };
        }
        case 'setCurrentPassword': {
            return {
                ...state,
                currentPassword: action.payload,
            }
        }
        case 'resetSettings': {
            return {
                ...state,
                passwordIsValid : false,
                textboxType: "password",
                currentPassword: "",
            }
        }
        default: 
            return state

    }
    
    
};